namespace TabAurous.OMS {
    export interface ProductSequenceRow {
        Id?: number;
        ProductId?: number;
        DepartmentId?: number;
        ProcessId?: number;
        StdLoss?: number;
        MaxLoss?: number;
        Duration?: number;
        Complexity?: number;
        Priority?: number;
        DeptName?: string;
        ProcessName?: string;
    }

    export namespace ProductSequenceRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'OMS.ProductSequence';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            ProductId = "ProductId",
            DepartmentId = "DepartmentId",
            ProcessId = "ProcessId",
            StdLoss = "StdLoss",
            MaxLoss = "MaxLoss",
            Duration = "Duration",
            Complexity = "Complexity",
            Priority = "Priority",
            DeptName = "DeptName",
            ProcessName = "ProcessName"
        }
    }
}
